// extracted by mini-css-extract-plugin
export var desktop = "Conditional-module--desktop--2FnwJ";
export var mobile = "Conditional-module--mobile--fuw3B";
export var desktopTablet = "Conditional-module--desktopTablet--uSlXV";
export var mobileTablet = "Conditional-module--mobileTablet--2rnsV";